import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col, Spinner, Image } from 'react-bootstrap'

const SHOW_FULL_AADHAAR = false
const maskAadhaar = (val) => {
    if (!val) return '—'
    if (SHOW_FULL_AADHAAR) return val
    const digits = String(val)
    return `•••• •••• ${digits.slice(-4)}`
}

const formatDate = (val) =>
    val
        ? new Date(val).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
        : '—'

export default function TeacherProfile() {

    const { profile, loading, error } = useSelector(
        (state) => state.auth
    ) || {};
    const teacher = profile?.teacherId || {};
    const institute = profile?.instituteId || {};
    const role = profile?.roleId || {};
    const classesAssigned = profile?.classTeacher || [];
    const isActive = !profile?.isDeleted;

    return (
        <>
            <div className="tp-sheet-page card p-3 mb-3" style={{ border: "none" }}>
                <Container >
                    {loading && (
                        <div className="tp-state">
                            <Spinner animation="border" variant="dark" role="status" />
                            <p className="mt-3 tp-state-text">Loading profile…</p>
                        </div>
                    )}

                    {!loading && error && (
                        <div className="tp-state">
                            <p className="tp-state-error">Couldn't load profile. {String(error)}</p>
                        </div>
                    )}

                    {!loading && !error && profile && (
                        <div className="tp-sheet">

                            <div className="tp-identity">
                                <div className="tp-identity-photo-wrap">
                                    <Image src={teacher?.image} alt={teacher?.name} className="tp-identity-photo" />
                                </div>

                                <div className="tp-identity-text">
                                    <span className="tp-eyebrow">Faculty Record</span>
                                    <h1 className="tp-identity-name">{teacher?.name || '—'}</h1>
                                    <div className="tp-identity-tags">

                                        {teacher?.dept && <span className="tp-tag tp-tag-dept">{teacher.dept}</span>}
                                        <span className={`tp-tag ${isActive ? 'tp-tag-active' : 'tp-tag-inactive'}`}>
                                            {isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                </div>

                                {institute?.instituteLogo && (
                                    <div className="tp-identity-institute">
                                        <Image src={institute.instituteLogo} alt={institute.instituteName} className="tp-institute-logo" />
                                        <span className="tp-institute-name">{institute?.instituteName}</span>
                                    </div>
                                )}
                            </div>

                            <div className="tp-rule" />


                            <section className="tp-section">
                                <h2 className="tp-section-title">
                                    <span className="tp-section-index">01</span> Contact
                                </h2>
                                <Row className="g-0 tp-record-grid">
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Email</span>
                                        <span className="tp-record-value">{teacher?.email || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Mobile</span>
                                        <span className="tp-record-value">{teacher?.mobileNo || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Address</span>
                                        <span className="tp-record-value">{teacher?.address || '—'}</span>
                                    </Col>
                                </Row>
                            </section>

                            {/* ===== Section: Personal ===== */}
                            <section className="tp-section">
                                <h2 className="tp-section-title">
                                    <span className="tp-section-index">02</span> Personal
                                </h2>
                                <Row className="g-0 tp-record-grid">
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Date of Birth</span>
                                        <span className="tp-record-value">{formatDate(teacher?.dob)}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Gender</span>
                                        <span className="tp-record-value">{teacher?.gender || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Nationality</span>
                                        <span className="tp-record-value">{teacher?.nationality || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Religion</span>
                                        <span className="tp-record-value">{teacher?.religion || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Aadhaar</span>
                                        <span className="tp-record-value">{maskAadhaar(teacher?.aadhaarNumber)}</span>
                                    </Col>
                                </Row>
                            </section>

                            {/* ===== Section: Institute ===== */}
                            <section className="tp-section">
                                <h2 className="tp-section-title">
                                    <span className="tp-section-index">03</span> Institute
                                </h2>
                                <Row className="g-0 tp-record-grid">
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Name</span>
                                        <span className="tp-record-value">{institute?.instituteName || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Code</span>
                                        <span className="tp-record-value">{institute?.instituteCode || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Email</span>
                                        <span className="tp-record-value">{institute?.instituteEmail || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Mobile</span>
                                        <span className="tp-record-value">{institute?.instituteMobileNo || '—'}</span>
                                    </Col>
                                </Row>
                            </section>

                            {/* ===== Section: Assignment ===== */}
                            <section className="tp-section">
                                <h2 className="tp-section-title">
                                    <span className="tp-section-index">04</span> Details
                                </h2>
                                <Row className="g-0 tp-record-grid">
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Experience</span>
                                        <span className="tp-record-value">
                                            {teacher?.experience != null ? `${teacher.experience} years` : '—'}
                                        </span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Education</span>
                                        <span className="tp-record-value">{teacher?.education || '—'}</span>
                                    </Col>
                                    <Col xs={12} md={4} className="tp-record-row">
                                        <span className="tp-record-label">Date of Joining</span>
                                        <span className="tp-record-value">{formatDate(teacher?.doj)}</span>
                                    </Col>
                                </Row>

                                {classesAssigned.length > 0 && (
                                    <div className="tp-classes">
                                        <span className="tp-record-label d-block mb-2">Classes Assigned</span>
                                        <div className="tp-class-list">
                                            {classesAssigned.map((cls, i) => (
                                                <span className="tp-class-chip" key={i}>
                                                    {cls.className} · {cls.sectionName}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </section>
                        </div>
                    )}

                    {!loading && !error && !profile && (
                        <div className="tp-state">
                            <p className="tp-state-text">
                                No profile data found.
                            </p>
                        </div>
                    )}
                </Container>
            </div>
        </>
    )
}